import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { Ask } from 'src/app/shareModule/models/ask.model';
import { loadCommunityAsk, selectAllCommunityAsk, selectLoading } from 'src/app/shareModule/states/community-ask';
import { filter } from 'rxjs';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-ask-carsouel',
  templateUrl: './ask-carsouel.component.html',
  styleUrls: ['./ask-carsouel.component.scss'],
})
export class AskCarsouelComponent implements OnInit {
  @Input() title: boolean = true;
  @Input() gridNumber: string = '';
  @Input() viewMode: boolean = false;
  @Input() categoryName: string = '';
  @Input() subCategoryName: string = '';
  @Input() onlyMemberAsk: Boolean = false;
  @Input() grid: boolean = true;
  @Input() slides: any = 2;
  public width: number;
  carouselOptions: any = {
    slidesPerView: this.grid ? 2 : 1,
    grid: {
      rows: this.grid ? 1 : 4,
      fill: 'row',
    },
    spaceBetween: 10,
    breakpoints: {
      1024: {
        slidesPerView: this.slides,
      },
    },
  };
  ngOnChanges(changes) {
    if (changes['grid'] || changes['slides']) {
      var rows = {};
      if (this.grid) {
        rows = {
          slidesPerView: 2,
          breakpoints: {
            1024: {
              slidesPerView: this.slides,
            },
          },
          grid: {
            rows: 2,
            fill: 'row',
          },
        };
      } else {
        rows = {
          slidesPerView: 1,
          grid: {
            rows: 4,
            fill: 'row',
          },
        };
      }
      this.carouselOptions = {
        ...rows,
        spaceBetween: 10,
      };
    }
  }

  @ViewChild('askPopup') askPopup: Element;
  public commonModelRef: any = null;
  public askMsg: string = '';
  public askList: Array<any> = [];
  public ask: any = {
    memberShopAskLikes: [],
  };
  public appUserId: any = 0;
  public isLogin: any = 0;
  public imgUrl = environment.ImageUrl;
  constructor(
    private store: Store<AppState>,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private customerService: CustomerService,
    public roleService: RoleService,
    private sharedService: SharedService,
    @Inject("WINDOW") private window: any,
  ) { }
  loading: any = false;
  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.width = this.window.innerWidth;
    }

    this.loading = true;
    const getUser = this.local.getUser();

    if (getUser) {
      this.appUserId = getUser.id;
    }

    getUser ? (this.isLogin = 1) : 0;


    this.store.pipe(select(selectAllCommunityAsk)).pipe(filter(resp => resp && resp.length > 0)).subscribe((response: any) => {
      this.askList = structuredClone(response);
      this.askList.map((row: any) => {
        row.createdAt = this.local.timeAgo(row.createdAt / 1000);
        if (row.createdAt != 'just now') row.createdAt += ' ago';
        row.profileImage = this.local.checkImageProfile(row.appUser)
      });
    });
    this.store.pipe(select(selectLoading)).subscribe((response: any) => {
      this.loading = response;
    });

    this.getAskList();
  }

  openAddPopup() {
    if (!this.categoryName || !this.subCategoryName) {
      this.toastr.error('Select CategoryName & SubCategoryName');
      return true;
    }

    if (this.askList.length >= 3) {
      this.toastr.error('Only Three Question can be added!');
      return true;
    }

    this.commonModelRef = this.modalService.open(this.askPopup, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public submitAsk() {
    this.auth
      .addMemberShopAsk({
        message: this.askMsg,
        category: this.categoryName,
        subCategory: this.subCategoryName,
      })
      .subscribe((resp: ApiResponse) => {
        this.askMsg = '';
        this.commonModelRef.close();
        this.toastr.success(resp.message);
        this.getAskList();
        this.store.dispatch(loadCommunityAsk());
      });
  }

  public getAskList() {
    this.store.dispatch(loadCommunityAsk());
  }

  public deleteAsk(id) {
    this.local.alertConfirm({
      message: 'Are you sure you want to delete this ask?'
    }).then((res) => {
      if (res.isConfirmed) {
        this.auth.deleteMemberShopAsk(id).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.modalService.dismissAll();
          this.getAskList();
        });
      }
    });
  }

  public viewAsk(modal, message, item?: any) {
    this.askMsg = message;
    this.commonModelRef = this.modalService.open(modal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'ask_detail_modal',
    });
    this.ask = item;
    this.ask.hiddenBy = JSON.parse(this.ask.hiddenBy);
  }

  hasCheckedForum(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0;
  }

  likeForum(askId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      askId: askId,
    };

    if (this.hasCheckedForum(data.memberShopAskLikes))
      data.memberShopAskLikes = data.memberShopAskLikes.filter(
        (row: any) => row.userId != this.appUserId
      );
    else data.memberShopAskLikes = [...data.memberShopAskLikes, payload];

    this.auth.likeMemberShopAsk(payload).subscribe();
  }

  public hideAsk(id) {
    this.customerService
      .hideMemberShopAsk({
        askId: id,
      })
      .subscribe(
        (resp: ApiResponse) => {
          this.toastr.success(resp.message);

          this.ask.hiddenBy.push(this.appUserId);
          this.getAskList();
        },
        (err) => {
          this.toastr.error(err.error.message);
        }
      );
  }
}
